import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid, { HubCardItem } from '../../components/PanelHubGrid';

const ALL_CARDS: (HubCardItem & { referentFunctions?: string[] })[] = [
  {
    to: '/panel/cta',
    title: 'Interventions CTA',
    description: 'Liste et suivi des interventions en cours.',
    accent: 'sky',
    referentFunctions: ['Référent Scénariste'],
  },
  {
    to: '/panel/interventions/create',
    title: 'Créer un scénario',
    description: "Nouveau scénario d'appel (ouvert à toute l'équipe).",
    accent: 'violet',
  },
  {
    to: '/panel/interventions/manage',
    title: 'Gérer les scénarios',
    description: 'Modifier les scénarios existants (fonction référent requise).',
    accent: 'violet',
    referentFunctions: ['Référent Scénariste', 'Référent GR'],
  },
  {
    to: '/panel/cta/categories-mission',
    title: 'Catégories de mission',
    description: 'Catégories utilisées par le CTA (fonction référent requise).',
    accent: 'emerald',
    referentFunctions: ['Référent Scénariste'],
  },
];

const PanelScenaristeHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection, hasReferentFunction } = usePanelAccess();
  const roleId = currentUser?.roles_id ?? 0;
  const canEnterHub = hasAccessToSection('salon_scenariste');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  const cards = useMemo(() => {
    return ALL_CARDS.filter((c) => {
      // Cards without referentFunctions are open to all hub members
      if (!c.referentFunctions || c.referentFunctions.length === 0) return true;
      // CM (role 1) bypasses all referent checks
      if (roleId === 1) return true;
      // Others need at least one of the listed referent functions
      return c.referentFunctions.some((fn) => hasReferentFunction(fn));
    });
  }, [hasReferentFunction, roleId]);

  if (!currentUser || loading || !canEnterHub) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Créer un scénario est ouvert à toute l'équipe (rôles 1 et 4). Les autres outils nécessitent une fonction référent assignée."
      cards={cards}
    />
  );
};

export default PanelScenaristeHubV1;
